const sunaval = [
    {
        label: "CONVOCATORIA ASAMBLEA DE ACCIONISTAS INVERSIONES CRECEPYMES EN PRENSA 08/03/2021",
        date: "08/03/2021",
        nameFile: "CONVOCATORIA ASAMBLEA DE ACCIONISTAS INVERSIONES CRECEPYMES EN PRENSA 08-03-2021.pdf"
    },
    {
        label: "Estados Financieros 2019_17 08 2020",
        date: "31/08/2020",
        nameFile: "Estados Financieros 2019_17 08 2020.pdf"
    },
    {
        label: "PRUEBA ASAMBLEA DE ACCIONISTAS INVERSIONES CRECEPYMES EN PRENSA 18/08/2020",
        date: "18/08/2020",
        nameFile: "CONVOCATORIA ASAMBLEA DE ACCIONISTAS INVERSIONES CRECEPYMES EN PRENSA.pdf"
    },
    {
        label: "SEGUNDA CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS 01/04/2019 - 8:30 AM",
        date: "01/04/2019",
        nameFile: "Segunda convocatoria ordinaria de accionistas 01042019 -830 AM).PDF"
    },
    {
        label: "INFORME DE INVERSIONES CRECEPYMES, C.A. A LOS ACCIONISTAS – GESTIÓN 2018",
        date: "31/12/2018",
        nameFile: "Crecepymes -Informe anual a los accionistas 2018.docx"
    },
    {
        label: "INFORME ANUAL A LOS ACCIONISTAS 2018",
        date: "31/12/2018",
        nameFile: "informe anual a los accionistas 2018.pdf"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2018 Y 2017",
        date: "31/12/2018",
        nameFile: "Estados financieros al 31 de diciembre de 2018 y 2017.pdf"
    },
    {
        label: "CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 26/03/2019 - 10:00 AM",
        date: "26/03/2019",
        nameFile: "PUBLICACION CONVOCATORIA ASAMBLEA 26-03-19.jpg"
    },
    {
        label: "INFORME ANUAL A LOS ACCIONISTAS 2017",
        date: "31/12/2017",
        nameFile: "Informe anual a los accionistas 2017.pdf"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2017 Y 2016",
        date: "31/12/2017",
        nameFile: "INVERSIONES CRECEPYMES ESTADOS FINANCIEROS AL 31-12-2017_2016.pdf"
    },
    {
        label: "CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 26/03/2018 - 10:00 AM",
        date: "26/03/2018",
        nameFile: "PUBLICACION CONVOCATORIA ASAMBLEA 26 MARZO 2018.jpg"
    },
    {
        label: "INFORME A LA ASAMBLEA DE ACCIONISTAS DEL AÑO 2016",
        date: "31/12/2016",
        nameFile: "Crecepymes-Informe anual a los accionistas 2016.docx"
    },
    {
        label: "INFORME A LA ASAMBLEA DE ACCIONISTAS DEL AÑO 2015",
        date: "31/12/2015",
        nameFile: "Crecepymes-Informe anual a los accionistas 2015.docx"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2016 Y 2015",
        date: "31/12/2015",
        nameFile: "MATRIZ Inversiones CRECEPYMES, C.A. 311216-15  10 03 2017.docx"
    },
    {
        label: "CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 28/03/2017 - 10:00 AM",
        date: "28/03/2017",
        nameFile: "PUBLICACION CONVOCATORIA ASAMBLEA 28 DE MARZO DE 2017.pdf"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2015 Y 2014",
        date: "31/12/2015",
        nameFile: "BALANCE AUDITADO 2015.pdf"
    },
    {
        label: "CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 31/03/2016 - 10:00 AM",
        date: "31/03/2016",
        nameFile: "publicacion asamblea 31 de marzo 2016.pdf"
    },
    {
        label: "ASAMBLEA EXTRAORDINARIA DE ACCIONISTAS 14 ENERO 2016",
        date: "14/01/2016",
        nameFile: "ASAMBLEA EXTRAORDINARIA DE ACCIONISTAS 14 ENERO 2016.pdf"
    },
    {
        label: "INFORME A LA ASAMBLEA DE ACCIONISTAS DEL AÑO 2014",
        date: "31/12/2014",
        nameFile: "Crecepymes-informe anual a los accionistas 2014.docx"
    },
    {
        label: "INFORME DEL COMISARIO BARBOZA AL 31 DE DICIEMBRE DE 2014",
        date: "31/12/2014",
        nameFile: "Crecepymes_Informe_Comisario_Barboza_16-04-15.pdf"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2014 Y 2013",
        date: "31/12/2014",
        nameFile: "Crecepymes_Edos_Financieros_Dic_2014-2013.pdf"
    },
    {
        label: "CARTA CONVOCATORIA ASAMBLEA GENERAL EXTRAORDINARIA DE ACCIONISTAS - 16/04/2015 - 8:00 AM",
        date: "16/04/2015",
        nameFile: "Crecepymes_I_Conv_Asamblea_Accionistas_16-04-15.doc"
    },
    {
        label: "CARTA CONVOCATORIA ASAMBLEA GENERAL EXTRAORDINARIA DE ACCIONISTAS - 16/04/2015 - 9:00 AM",
        date: "16/04/2015",
        nameFile: "Crecepymes_II_Conv_Asamblea_Accionistas_16-04-15.doc"
    },
    {
        label: "INFORME DEL COMISARIO BARBOZA AL 31 DE DICIEMBRE DE 2013",
        date: "31/12/2013",
        nameFile: "Informe_comisario_Barboza.pdf"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE MARZO DE 2014 Y 2013",
        date: "31/03/2014",
        nameFile: "Edos_Financieros_Crecepymes_marzo 2014-13.pdf"
    },
    {
        label: "INFORME DE PREPARACIÓN DE LOS CONTADORES PÚBLICOS INDEPENDIENTES ANTES DE REDUCCIÓN CAPITAL",
        date: "01/01/2014",
        nameFile: "Informe de antes Reduccion de Capital.jpg"
    },
    {
        label: "BALANCE GENERAL 31 DE DICIEMBRE DE 2013 ANTES DE REDUCCIÓN CAPITAL",
        date: "31/12/2013",
        nameFile: "Balance Gral antes de Reduccion de Capital.jpg"
    },
    {
        label: "INFORME DE PREPARACIÓN DE LOS CONTADORES PÚBLICOS INDEPENDIENTES DESPUÉS DE REDUCCIÓN CAPITAL",
        date: "31/12/2013",
        nameFile: "Informe despues de Reduccion de Capital.jpg"
    },
    {
        label: "BALANCE GENERAL 31 DE DICIEMBRE DE 2013 DESPUÉS DE REDUCCIÓN CAPITAL",
        date: "31/12/2013",
        nameFile: "Balance Gral despues de Reduccion de Capital.jpg"
    },
    {
        label: "CONVOCATORIA ASAMBLEA EXTRAORDINARIA - 28/04/2014 - 9:00 AM",
        date: "28/04/2014",
        nameFile: "Publicacion_Asamblea_Extraordinaria28-04-14.jpg"
    },
    {
        label: "INFORME A LA ASAMBLEA DE ACCIONISTAS DEL AÑO 2013",
        date: "01/01/2013",
        nameFile: "Crecepymes-informe anual a los accionistas 2013.doc"
    },
    {
        label: "INFORME DEL COMISARIO AD-HOC AL 31 DE DICIEMBRE DE 2013",
        date: "31/12/2013",
        nameFile: "Informe_del_Comisario_Ad-Hoc.doc"
    },
    {
        label: "INFORME DEL ÁREA DE PREVENCIÓN DE LEGITIMACIÓN DE CAPITALES AL 31 DE DICIEMBRE DE 2013",
        date: "31/12/2013",
        nameFile: "Informe_Legitimacion_Crecepymes.doc"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2013 Y 2012",
        date: "31/12/2013",
        nameFile: "Edos_Financieros_Crecepymes_2013-12.doc"
    },
    {
        label: "CARTA CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 31/03/2014 - 8:00 AM",
        date: "31/03/2014",
        nameFile: "Carta_Conv_Asamblea_31-03-2014.doc"
    },
    {
        label: "PUBLICACIÓN CONVOCATORIA ASAMBLEA GENERAL ORDINARIA DE ACCIONISTAS - 15/03/2014",
        date: "15/03/2014",
        nameFile: "Publicacion_Conv_Asamblea_31-03-2014.jpg"
    },
    {
        label: "CONVOCATORIA ASAMBLEA EXTRAORDINARIA CONSIDERACIÓN ESTADOS FINANCIEROS - 03/04/2013 - 9:00 AM",
        date: "03/04/2013",
        nameFile: "Conv_Edos_Financieros.doc"
    },
    {
        label: "CARTA PODER PARA ASAMBLEA EXTRAORDINARIA - 03/04/2013 - 9:00 AM",
        date: "03/04/2013",
        nameFile: "Carta_Poder_Edos_Financieros.doc"
    },
    {
        label: "CONVOCATORIA ASAMBLEA EXTRAORDINARIA MODIFICACIÓN ESTATUTOS - 03/04/2013 - 8:00 AM",
        date: "03/04/2013",
        nameFile: "Conv_modificar_Doc_Constitutivo.doc"
    },
    {
        label: "CARTA PODER PARA ASAMBLEA EXTRAORDINARIA - 03/04/2013 - 8:00 AM",
        date: "03/04/2013",
        nameFile: "Carta_Poder_Doc_Constitutivo.doc"
    },
    {
        label: "PROYECTO MODIFICACIÓN CLÁUSULAS DEL DOCUMENTO CONSTITUTIVO",
        date: "03/04/2013",
        nameFile: "Doc_Constitutivo_Estat_Inv_Crecepymes.doc"
    },
    {
        label: "ESTADOS FINANCIEROS AL 31 DE DICIEMBRE DE 2012 Y 2011",
        date: "31/12/2012",
        nameFile: "Edos_Financieros_Crecepymes_2012.doc"
    }
  ]

export default sunaval
